export const painPoints = [
  { emoji: '🧱', text: 'You stare at the screen for hours without being able to start.' },
  { emoji: '📱', text: 'You say “just one second” and lose two hours on your phone.' },
  { emoji: '🗓️', text: 'You buy planners and calendars, then abandon them within three days.' },
  { emoji: '⏸️', text: 'You know exactly what to do, but your body will not move.' },
  { emoji: '🌙', text: 'You go to bed guilty because the day passed without doing anything important.' },
  { emoji: '🔁', text: 'Every Monday you promise to change. By Thursday, you have already quit.' },
]

export const features = [
  {
    title: 'The Dopamine Blueprint',
    pain: 'Pain: The “lazy” identity',
    description: 'Understand why your brain seems to fail and how to reset the neurological pattern that creates chronic guilt.',
  },
  {
    title: 'The Action Trigger System',
    pain: 'Pain: Starting paralysis',
    description: 'Move from total inertia into action in under 60 seconds with tiny, reliable movement triggers.',
  },
  {
    title: 'Deep Work for Scattered Brains',
    pain: 'Pain: Chronic distraction',
    description: 'Build a focus bubble that protects your work from notifications, people, and your own impulsive brain.',
  },
  {
    title: 'The Decision Matrix',
    pain: 'Pain: Overthinking & paralysis',
    description: 'Stop overthinking every decision. Use the Matrix to choose what matters and what can wait in seconds.',
  },
  {
    title: 'Emotional Regulation & Guilt',
    pain: 'Pain: Shame & burnout',
    description: 'Break the guilt spiral that turns one bad day into a lost week. Rebuild your productive identity.',
  },
  {
    title: 'The Unstoppable Habit Loop',
    pain: 'Pain: Chronic inconsistency',
    description: 'Turn everything you learn into an automatic system that works even on your hardest days.',
  },
]

export const bonuses = [
  {
    emoji: '⏱️',
    tag: 'Bonus #1',
    title: 'The 10-Minute DONE. Daily Planner',
    description: 'Choose the three tasks that truly matter before you touch your phone. A focused 25-page planner.',
  },
  {
    emoji: '📵',
    tag: 'Bonus #2',
    title: 'Anti-Scroll Dopamine Reset Checklist',
    description: 'A 15-minute digital reset to reclaim up to two hours a day from endless scrolling.',
  },
  {
    emoji: '🚨',
    tag: 'Bonus #3',
    title: 'ADHD Emergency First-Aid Kit',
    description: 'A five-minute rescue protocol for days when everything collapses and shame leaves you stuck.',
  },
  {
    emoji: '🫧',
    tag: 'Bonus #4',
    title: 'The Focus Bubble Workspace Map',
    description: 'Redesign your desk into five execution zones that make focus the default option.',
  },
  {
    emoji: '🤝',
    tag: 'Bonus #5',
    title: 'Body Doubling & Accountability Script Vault',
    description: 'Copy-and-paste scripts for creating work sessions with others instead of trying to do it all alone.',
  },
]

export const offerChecklist = [
  'DONE. — complete 6-volume system',
  'Bonus #1 — 10-Minute DONE. Daily Planner',
  'Bonus #2 — Anti-Scroll Dopamine Reset Checklist',
  'Bonus #3 — ADHD Emergency First-Aid Kit',
  'Bonus #4 — Focus Bubble Workspace Map',
  'Bonus #5 — Body Doubling & Accountability Script Vault',
  'Instant digital access — yours forever',
]

export const outcomes = [
  'Start tasks that used to paralyze you in under 60 seconds.',
  'Recover the hours you currently lose to endless scrolling.',
  'End the day feeling like you moved forward, not merely stayed busy.',
  'Have a system that works even on your hardest days.',
  'Stop going to bed guilty about what you did not do.',
  'Turn inconsistency into automatic, compounding progress.',
]

export const faqs = [
  {
    question: 'Do I need an ADHD diagnosis to use DONE.?',
    answer: 'No. DONE. is for anyone who recognizes task paralysis, distraction, and inconsistency in their day-to-day life. If you have an ADHD diagnosis, its tools are designed around the way your brain activates; if you do not, you can still use the system.',
  },
  {
    question: 'Does this replace therapy, medication, or treatment?',
    answer: 'No. DONE. is an educational, practical resource for personal organization. It does not diagnose, treat, or replace care from qualified mental-health professionals.',
  },
  {
    question: 'How do I receive the system after purchase?',
    answer: 'Immediately. Once your payment is complete, you receive digital access to all six volumes and five bonuses. Use them on your phone, tablet, or computer.',
  },
  {
    question: 'Is it difficult to implement?',
    answer: 'No. The system is made to reduce friction, not add an impossible routine. You begin with short protocols, clear scripts, and triggers you can use today.',
  },
  {
    question: 'What if I do not feel an improvement?',
    answer: 'You are protected by a full 7-day guarantee. If you apply the system for 7 days and do not experience a real improvement in starting, focusing, and finishing tasks, we will refund 100% of your investment.',
  },
]
